import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getManagerReportReq,
  getManagerReportResClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from 'react-select'
import { useTranslation } from "react-i18next";
const ChooseManager = (props) => {

  const {
    selectedManagerCoachList, setSelectedManagerCoachList,
    parentId, parentName,
    isMobile, selectedBrokerageList
  } = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const { courseId } = useParams();
  const managerSearchRes = useSelector(
    (state) => state.assignCourse.managerReportList
  );
  const assignedUserRes = useSelector(
    (state) => state.assignCourse.assignedUsers
  );
  const [searchInput, setSearchInput] = useState("");
  const [managerList, setManagerList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [managerOptList, setManagerOptionList] = useState([])
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    dispatch(getManagerReportResClear());
    searchManager()
    setIsLoading(true)
    return (() => {
      dispatch(getManagerReportResClear());
    })
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true)
    searchManager()
    setManagerOptionList([])
    setManagerList([])
    setSelectedManagerCoachList([])
  }, [selectedBrokerageList])

  useEffect(() => {
    setSelectedCount(selectedManagerCoachList?.length);

    const newDefaultValue = selectedManagerCoachList.map((manager) => ({
      value: manager.id,
      label: manager.user_name,
		  }));
	  
		  setDefaultValue(newDefaultValue);
  }, [selectedManagerCoachList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2)
      searchManager();
    else setErrorMsg("");
  }, [searchInput]);

  const searchManager = () => {
    dispatch(
      getManagerReportReq({
        module: "getTeamManageCoachMentor",
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
          brokerage: selectedBrokerageList
        },
      })
    );
  };



  useEffect(() => {
    // console.log("managerSearchRes: ", managerSearchRes);
    if (!_.isEmpty(managerSearchRes)) {
      setErrorMsg("");
      if (managerSearchRes?.status === "success") {
        const mList = managerSearchRes?.payload?.payload
        setManagerList(mList);
        setManagerOptionList(_.map(mList, (manager) => {
					return {
						value: manager.id,
						label: manager.user_name,
					}
				}))
      } else {
        setManagerList([]);
        setManagerOptionList([])
        if (!_.isEmpty(searchInput) && searchInput?.length > 2) {
          setErrorMsg(t("No result found for your search."));
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false)
    } else {
      setManagerList([]);
      setErrorMsg("");
    }
  }, [managerSearchRes]);




  const selectItem = (index) => {
    let tempArr = _.cloneDeep(managerList);
    let selectedTempArray = _.cloneDeep(selectedManagerCoachList);
    if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 1)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedManagerCoachList(selectedTempArray);
    tempArr.splice(index, 1);
    setManagerList(tempArr);

  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedManagerCoachList);
    let tempArr = _.cloneDeep(managerList);

    if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 1)) {
      tempArr.push(selectedTempArray[index]);
    }

    setManagerList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedManagerCoachList(selectedTempArray);
  };

  return (
    <>
      <div className="chooseteamate">
        <h4>{t("Choose Team Manager")}</h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label">
            {t("Search")}
          </label>
          {/* <input
            type="text"
            id="teamsearch"
            name="teamsearch"
            className="input_searchfield_search-cart "
            placeholder="Start searching"
            onChange={(evt) => {
              setSearchInput(evt.target.value);
            }}
          /> */}
          <Select 
							isMulti
							name="colors"
							className="basic-multi-select w-100 multi-label-select"
    						classNamePrefix="xsel"
							options={managerOptList}
              value={defaultValue}
              isLoading={isLoading}
							onChange={(e) => {
								console.log(e)
								// setSelectedOffice(e)
								if (!_.isEmpty(e)) {
									setErrorMsg('')
									let data = [];
									for (let manager of managerList) {
										for (let sO of e) {
											if (sO.value === manager.id) {
												data.push(manager)
											}
										}
									}
									setSelectedManagerCoachList(data)
								} else {
									setSelectedManagerCoachList([])
									// setErrorMsg("Please select at lease one manager.");
								}
							}}
						/>
        </div>
        <p className="error-msg">{errorMsg}</p>
        {/* <div className="search-team-result">
          {managerList?.map((item, index) => {
            return (
              <div className="team-result-box">
                <div className="team-user-img">
                  <img
                    src={
                      item?.profile_img !== ""
                        ? item?.profile_img
                        : "/images/avatar.svg"
                    }
                    alt="user"
                  />
                </div>
                <div className="userteamname">{item?.user_name}</div>
                <div
                  className="addteammate cursor-pointer"
                  onClick={() => {
                    selectItem(index);
                  }}
                >
                  +
                </div>
              </div>
            );
          })}
        </div>
        <div className="teamselected">
          <div className="selectresilt">
            Selected Manager<strong>({selectedCount})</strong>
          </div>
          <div className="search-team-result slectedteammates">
            {selectedManagerCoachList?.map((item, index) => {
              return (
                <div className="team-result-box">
                  <div className="team-user-img">
                    <img
                      src={
                        item?.profile_img !== ""
                          ? item?.profile_img
                          : "/images/avatar.svg"
                      }
                      alt="user"
                    />
                  </div>
                  <div className="userteamname">{item?.user_name}</div>
                  <div
                    className="addteammate cursor-pointer"
                    onClick={() => {
                      //   console.log("removeItem");
                      removeItem(index);
                    }}
                  >
                    +
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}



        {false && <div className="buttonsteammate">
          {false && <button
            type="button"
            className="btn btn-primary btn-block back-button"
            onClick={() => {
              dispatch(setCurrentFilterView(1));
            }}
          >
            Back
          </button>}

          <button
            type="button"
            className="btn btn-primary btn-block setup-button"
            onClick={() => {
              setSelectedManagerCoachList(selectedManagerCoachList);
              // dispatch(setCurrentFilterView(1));
            }}
          >
            Apply
          </button>
        </div>}




      </div>
    </>
  );
};

export default ChooseManager;
